import { IntlProvider } from 'react-intl';

const messages = {};

const LocaleProvider = props => {
  const handleIntlError = error => {
    console.error(error);
  };

  return (
    <IntlProvider
      key={process.env.NEXT_PUBLIC_DEFAULT_LOCALE}
      {...props}
      defaultLocale={process.env.NEXT_PUBLIC_DEFAULT_LOCALE}
      locale={process.env.NEXT_PUBLIC_DEFAULT_LOCALE}
      messages={messages}
      onError={handleIntlError}
    />
  );
};

export default LocaleProvider;
